import React from "react";
import "./style.scss";
import BaseFormPage from "../../components/BaseFormPage";
import FormHeader from "../../components/FormHeader";
import RecoveryForm from "./components/RecoveryForm";
import { useTranslation } from "react-i18next";
import ROUTES from "../../utils/routes.js";
export default function RecoveryPage() {
  const { t } = useTranslation();
  return (
    <BaseFormPage backTo={ROUTES.LOGIN_PAGE}>
      <FormHeader title={t("recovery_page.recovery_title")} />
      <RecoveryForm />
    </BaseFormPage>
  );
}
